module.exports = __webpack_public_path__ + "img/reglesPage.8613fb17.png";